/** @format */

export const AppConfig = {
  apiUrl: process.env.REACT_APP_API_ENDPOINT || "https://api.transport.staging.bfast-vn.net/api",
  // apiUrl: "http://localhost:3000/api",
  mapsAPIKey: process.env.GOOGLE_MAPS_API_KEY || "AIzaSyBVra377vUKJOAviq_OTOfU89NqmGOXhZA",
  PTVKey: process.env.REACT_APP_PTV_SECRET_KEY || "RVVfNzUwYzJlMjZlYmQ4NDA5YzhiMjg3YTc4OTY5NzMxMTM6OWQxYjRmY2MtZTdiMi00NjE1LThiMjEtZmI5OGRhMWYyZWJk",
  routerBase: process.env.PUBLIC_URL || "",
};
